export default "<app-page-title [settings]=\"pageTitle\"></app-page-title>"